import { render, staticRenderFns } from "./IcoPublicLearningContent.vue?vue&type=template&id=3e790092"
import script from "./IcoPublicLearningContent.vue?vue&type=script&lang=js"
export * from "./IcoPublicLearningContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports